import { Box } from "@mui/material"

export function BooleanEntryValue({...params}){

    let pageMode = params.pageMode
    let stateObject = params.stateObject
    let setStateObjectEntryFieldHelper = params.setStateObjectEntryFieldHelper
    let title = params.title

    let placeholder = ''
    if (stateObject[title].currentValue === "" && stateObject[title].currentInput === "") placeholder = stateObject[title].oldValue
    else if (stateObject[title].currentValue !== "" && stateObject[title].currentInput === "") placeholder = stateObject[title].currentValue
    else if (stateObject[title].currentInput !== "") placeholder = stateObject[title].currentInput

    const handleBooleanClick = () => {

        if (pageMode === 'read' || stateObject[title].lockState) return
        else if (pageMode === 'edit' && !stateObject[title].lockState){

            let updatedValue = ''
            if (placeholder === true) updatedValue = false
            else if (placeholder === false) updatedValue = true

            setStateObjectEntryFieldHelper(title, 'currentInput', updatedValue)
            setStateObjectEntryFieldHelper(title, 'updatedState', updatedValue)
        }
    }


    let imageSrc = ''
    let imageHeight = ''
    if (placeholder === true) {
        imageHeight = '28px'
        imageSrc = '/icons/icons-shared/icon-checkmark-green.svg'
    }
    
    else if (placeholder === false) {
        imageHeight = '20px'
        imageSrc = '/icons/icons-shared/icon-xmark-dark.svg'
    }

    return (
        <Box 
            component="img" 
            src={imageSrc}
            width={'20px'} 
            height={imageHeight}
            padding={0}
            onClick={handleBooleanClick}
            alignSelf={'center'}
        />
    )
}
